import { en } from "./locales/en";
import { fr } from "./locales/fr";
import type {
  MenuTranslationKey,
  SupportedLocale,
  TranslateFn,
  TranslateParams,
  TranslationDictionary,
} from "./types";

export const DEFAULT_LOCALE: SupportedLocale = "fr";
export const FALLBACK_LOCALE: SupportedLocale = "en";

const dictionaries: Record<SupportedLocale, TranslationDictionary> = {
  fr,
  en,
};

export const SUPPORTED_LOCALES: SupportedLocale[] = ["fr", "en"];

export function isSupportedLocale(value: string): value is SupportedLocale {
  return value === "fr" || value === "en";
}

export function resolveDefaultLocale(): SupportedLocale {
  const fromEnv = import.meta.env.VITE_ITAAS_DEFAULT_LOCALE?.trim();
  if (fromEnv && isSupportedLocale(fromEnv)) {
    return fromEnv;
  }
  return DEFAULT_LOCALE;
}

function interpolate(
  template: string,
  params?: TranslateParams
): string {
  if (!params) return template;
  return Object.entries(params).reduce(
    (text, [key, value]) =>
      text.replace(new RegExp(`\\{${key}\\}`, "g"), String(value)),
    template
  );
}

export function createTranslator(locale: SupportedLocale): TranslateFn {
  const primary = dictionaries[locale];
  const fallback = dictionaries[FALLBACK_LOCALE];

  return (key: MenuTranslationKey, params?: TranslateParams) => {
    const template = primary[key] ?? fallback[key] ?? key;
    return interpolate(template, params);
  };
}
